<template>
  <div>
    <base-toolbar :title="$store.state.mycard_page_title"></base-toolbar>

    <v-container fluid class="pt-0">
      <v-row justify="center" class="d-none d-sm-flex">
        <v-col cols="12" md="8" class="page-title">
          {{ $store.state.mycard_page_title }}
        </v-col>
      </v-row>

      <v-row justify="center" class="border-t">
        <v-col md="8">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "My Cards",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: undefined
      }
    ]
  },

  components: {
    BaseToolbar: () => import("@/components/BaseToolbar")
  },

  data() {
    return {
      template_type_list: [],
      template_type_id_list: [],
      by_photo_filter_option: ["Both", "With Photo", "Without Photo"],
      by_photo_filter: [],
      sort_by: "",
      sort_by_option: []
    };
  }
};
</script>
